import { render, staticRenderFns } from "./scribingDetails.vue?vue&type=template&id=6530b638&scoped=true"
import script from "./scribingDetails.vue?vue&type=script&lang=js"
export * from "./scribingDetails.vue?vue&type=script&lang=js"
import style0 from "./scribingDetails.vue?vue&type=style&index=0&id=6530b638&prod&scoped=true&lang=less"
import style1 from "./scribingDetails.vue?vue&type=style&index=1&id=6530b638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530b638",
  null
  
)

export default component.exports